<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 33.333333%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
.fixHeightScrollable {
  overflow: auto;
  height: 500px;
}
hr {
  border: none;
  height: 0.5px;
  /* Set the hr color */
  color: #ccc; /* old IE */
  background-color: #ccc; /* Modern Browsers */
}
</style>

<template>
  <div>
      <div class="d-flex justify-content-between">
        <h5>Drilled Section</h5>
          <div>
            <DxButton
              icon="download"
              hint="Download Drilled Section excel file"
              :height="40"
              />
            <DxButton
              id="refreshButton"
              icon="revert"
              hint="Refresh"
              :height="40"
              @click="refreshGrid" />
          </div>
      </div>
      <br />
      <div class="overflow-auto">
        <DxDataGrid
          id="report-grid"
          ref="drilledSectionGrid"
          :data-source="drilledSectionDataSource"
          :show-borders="false"
          :show-column-lines="false"
          :show-row-lines="true"
          column-resize-mode="nextColumn"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :cell-hint-enabled="true"
          :word-wrap-enabled="true"
          :column-auto-width="false"
          :remote-operations="true"
          @row-inserted="onRowInserting"
          @row-updated="onRowUpdated"
          @row-removed="onRowRemoved"
          @editing-start="onEditingStart"
        >
        <DxScrolling mode="virtual" column-rendering-mode="standard"/>
        <DxEditing
          :allow-updating="editable"
          :allow-adding="editable"
          :allow-deleting="editable"
          :use-icons="true"
          mode="form"
        />
        <DxColumn
              type="buttons"
              width="120"
            >
              <GridButton name="edit"/>
              <GridButton name="delete"/>
            </DxColumn>
            <!-- DxColumn caption="No." cell-template="rowNoTemplate" width="50">
              <DxFormItem :visible="false"/>
            </DxColumn>
            <template #rowNoTemplate="{ data }">
              {{ data.rowIndex + 1 }}
            </template -->
        <DxColumn caption="No." :calculate-cell-value="setReportNo"  width="70" >
            <DxFormItem :visible="false"/>
        </DxColumn>
        <DxColumn data-field="section" data-type="string" caption="Section" />
        <DxColumn data-field="holeDiameter" data-type="string" caption="Hole Diameter">
          <DxLookup
            :data-source="optionSizes"
            value-expr="value"
            display-expr="text"/>
        </DxColumn>
        <DxColumn data-field="endDepth" data-type="number" caption="End Depth"/>
        <DxColumn data-field="casingSpecification" data-type="string" caption="Casing Specification"/>
        <DxColumn data-field="casingDepth" data-type="number" caption="Casing Depth"/>
        <DxColumn caption="Rat Hole" :calculate-cell-value="calculateRatHole">
          <DxFormItem :visible="false"/>
        </DxColumn>
        <DxColumn data-field="customInformation" data-type="string" caption="Custom Information" />
        </DxDataGrid>
      </div>
    </div>
</template>

<script>
import { formMethods, formComputed, authComputed } from '@state/helpers'
import axios from 'axios'
import qs from 'querystring'
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxFormItem,
  DxLookup,
  DxButton as GridButton,
  DxScrolling,
} from 'devextreme-vue/data-grid'
import notify from "devextreme/ui/notify"
import DxButton from 'devextreme-vue/button'
import mapApiUrl from '@/src/utils/api-mapper'
import CustomStore from 'devextreme/data/custom_store'

const isNotEmpty = (value) => value !== undefined && value !== null && value !== ''

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxFormItem,
    DxLookup,
    DxButton,
    GridButton,
    DxScrolling,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    submitId: {
        type: Number,
        default: undefined,
    },
    editable: {
        type: Boolean,
        default: false,
    },
    wellId: {
        type: Number,
        default: undefined,
    },
    reportMap: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      drilledSectionDataSource: null,
      currentlyEditable: false,
      optionSizes: [],
      casingSizes: ['4 1/2', '5', '5 1/2', '6 5/8', '7', '7 5/8', '7 3/4', '7 7/8', '8 5/8', '9 5/8', '9 7/8', '10 3/4', '11 3/4', '11 7/8', '12 1/4', '13 3/8', '13 1/2', '13 5/8', '14', '14 3/4', '16', '17 1/2', '18 5/8', '20', '22', '24', '26', '30', '32', '36', '40', '42'],
    }
  },
  computed: {
    ...formComputed,
    ...authComputed,
    uploadUrl() {
      return mapApiUrl('/api/form/master/drilling-parameters/upload')
    },
    uploadHeaders() {
      return {Authorization: `Bearer ${this.currentUser.token}`}
    },
  },
  watch: {
    submitId: function (value) {
      this.refreshGrid()
    },
    editable: function (val) {
    },
  },
  created: function () {
    this.populateOptionSize()
    this.init()
  },
  methods: {
    ...formMethods,
    init() {
      this.drilledSectionDataSource = new CustomStore({
        key: 'id',
        load: (loadOptions) => {
            let params = {}
            params.wellId = this.wellId
            let options = [ 'filter', 'group', 'groupSummary', 'parentIds', 'requireGroupCount', 'requireTotalCount', 'searchExpr', 'searchOperation',
              'searchValue', 'select', 'sort', 'skip', 'take', 'totalSummary', 'userData'
            ]
            options.forEach(function(i) {
              if(i in loadOptions && isNotEmpty(loadOptions[i])) {
                params[i] = loadOptions[i]
              }
            });
          const url = mapApiUrl('/api/form/master/drilled-section/list-paged/well')
          return axios.get(url, {params: params})
               .then((response) => {
                 const result = []
                 for (const entry of response.data.data) {
                   let item = {...entry}
                   const match = this.reportMap.findIndex(x => x.submitId === item.submitId)
                   if (match >= 0) {
                     item.reportNo = match 
                   }
                   result.push(item)
                 }
                 return {data: result, totalCount: response.data.totalCount}
                 })
               .catch(error => new Error(error.message)) 
        },
        onLoaded: (result) => {
            // Result is the array of data received from your backend
            console.log("Store received this data:", result);
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0])
            }
        },
        insert: (values) => {
          values.submitId = this.submitId
          values.dailyReportId = this.submitId
          if (isNaN(values.id)) {
            delete values.id
          }
          const url = mapApiUrl('/api/form/master/drilled-section/add')
          return axios.post(url, qs.stringify(values)).then(response => response) 
        },
        update: (key, values) => {
          values.submitId = this.submitId
          values.id = key
          const url = mapApiUrl('/api/form/master/drilled-section/add')
          return axios.post(url, qs.stringify(values)).then(response => response) 
        },
        remove: (key) => {
        const url = mapApiUrl('/api/form/master/drilled-section/delete')
          return fetch(url + `?id=${key}&submitId=${this.submitId}`, {
                    method: 'DELETE',
                    headers: { 'Authorization': 'Bearer ' + this.currentUser.token,
                               'Content-Type': 'application/json'
                      }})
            // .then(handleErrors)
            .then(response => { 
                if (!response.ok) throw new Error('Network error') })
        },
      })
    },
    populateOptionSize() {
      this.optionSizes = []
      for (const size of this.casingSizes) {
        this.optionSizes.push({value: size, text: size})
      }
    },
    calculateRatHole(rowData) {
      let ratHole = 0
      if (rowData.endDepth && rowData.casingDepth && !isNaN(rowData.endDepth) && !isNaN(rowData.casingDepth)) {
        ratHole = rowData.endDepth - rowData.casingDepth
      }
      return ratHole
    },
    refreshGrid() {
      this.$refs.drilledSectionGrid.instance.refresh()
    },
    setReportNo(rowData) {
      const match = this.reportMap.find(x => x.submitId === rowData.submitId)
      return match !== undefined ? match.index : ""
    },
    saveRows(e) {
      notify({ message: 'Drilled section data has been recorded.', width: 500 }, 'success', 3000)
    },
    onRowRemoved(e) {
      notify({ message: 'Drilled section data has been removed.', width: 500 }, 'success', 3000)
    },
    onRowUpdated(e) {
      notify({ message: 'Drilled section data has been updated.', width: 500 }, 'success', 3000)
    },
    onRowInserting(e) {
      notify({ message: 'Drilled section data has been recorded.', width: 500 }, 'success', 3000)
    },
    onEditingStart(e) {
      this.currentlyEditable = this.editable && this.submitId === e.data.submitId
      e.cancel = !this.currentlyEditable
      if (e.cancel) {
        notify({ message: 'You can not change/remove other report.', width: 300 }, 'warning', 3000)
      }
    },
  }
}
</script>